import { createAsyncThunk } from "@reduxjs/toolkit";
import { loginInstance } from "../Config";

export const loginAction = createAsyncThunk("log-in", async (payload) => {
    const apiResponse = await loginInstance.post(`/login`, payload);
    return apiResponse.data;
}
);